import axios from "axios";
import * as HeaderFiles from "../../header/header";

const apiGetAdminTokenDetails = HeaderFiles.apiGetAdminTokenDetails;

// Action Types
export const SET_ADMIN_DATA = "SET_ADMIN_DATA";

// Keep a single request in flight even if AppInbox is mounted more than once.
// Also keep a short cache so changing/searching views cannot repeatedly hit
// getAdminTokenResult.
let adminDetailsRequest = null;
let adminDetailsRequestToken = null;
let cachedAdminToken = null;
let cachedAdminResult = null;
let cachedAdminAt = 0;

const ADMIN_DETAILS_TIMEOUT = 10000;
const ADMIN_DETAILS_CACHE_MS = 60 * 1000;

// Action Creator (Thunk)
export const getAdminDetails = (forceRefresh = false) => async (dispatch) => {
    const adminData = localStorage.getItem("admin_token_ticket_app");

    if (!adminData) {
        cachedAdminToken = null;
        cachedAdminResult = null;
        cachedAdminAt = 0;
        return null;
    }

    // Reuse a successful response for the current login token.
    if (
        !forceRefresh &&
        cachedAdminResult &&
        cachedAdminToken === adminData &&
        (Date.now() - cachedAdminAt) < ADMIN_DETAILS_CACHE_MS
    ) {
        dispatch({
            type: SET_ADMIN_DATA,
            payload: cachedAdminResult
        });

        return cachedAdminResult;
    }

    // Do not create another identical request while one is pending.
    if (
        adminDetailsRequest &&
        adminDetailsRequestToken === adminData
    ) {
        const result = await adminDetailsRequest;

        if (result) {
            dispatch({
                type: SET_ADMIN_DATA,
                payload: result
            });
        }

        return result || null;
    }

    const requestToken = adminData;
    adminDetailsRequestToken = requestToken;

    adminDetailsRequest = (async () => {
        try {
            const response = await axios.post(
                apiGetAdminTokenDetails,
                {
                    adminData: requestToken
                },
                {
                    timeout: ADMIN_DETAILS_TIMEOUT
                }
            );

            if (
                !response ||
                !Array.isArray(response.data) ||
                !response.data[0]
            ) {
                throw new Error("Invalid admin details response");
            }

            const adminRes = response.data[0];

            // Never cache data for an old login token.
            if (
                localStorage.getItem("admin_token_ticket_app") === requestToken
            ) {
                cachedAdminToken = requestToken;
                cachedAdminResult = adminRes;
                cachedAdminAt = Date.now();
            }

            dispatch({
                type: SET_ADMIN_DATA,
                payload: adminRes
            });

            return adminRes;

        } catch (error) {
            console.error(
                "Redux admin fetch error:",
                error && (
                    error.code ||
                    (error.response && error.response.status) ||
                    error.message
                )
            );

            // If a previous successful response exists for this token,
            // let the inbox continue instead of leaving it in a loading state.
            if (
                cachedAdminResult &&
                cachedAdminToken === requestToken
            ) {
                return cachedAdminResult;
            }

            return null;

        } finally {
            adminDetailsRequest = null;
            adminDetailsRequestToken = null;
        }
    })();

    return adminDetailsRequest;
};

export const clearAdminDetailsCache = () => {
    cachedAdminToken = null;
    cachedAdminResult = null;
    cachedAdminAt = 0;
};
